const pending = (type) => ({ type: `${type}_PENDING` });
const rejected = (type, err) => ({
  type: `${type}_REJECTED`,
  payload: err,
});
const fulfilled = (type, payload) => ({ type: `${type}_FULFILLED`, payload });

export { pending, rejected, fulfilled };
